/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

/* components */
import ExperienceForm from "./ExperienceForm";
import Page from "../../shared/Page";
import ChangeHistory from "../../shared/ChangeHistory";

import GetItem from "../../../helpers/dataProviders/getItem";

class ExperienceFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "An";
		this.label = "Experience";
		this.expId = props.match.params.id ? props.match.params.id : 0;
		this.state = {
			item: null,
		};
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Create {this.indefiniteArticle} {this.label}
				</h3>
				<ExperienceForm
					cultures={this.props.cultures}
					onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
					buttonLabel={`Create ${this.label}`}
					getFormApi={this.props.getFormApi}
					hasFormApi={this.props.hasFormApi}
					initialValues={{ culture: "en-US" }}
				/>
			</div>
		);
	};

	renderCopyForm = () => {
		if (this.state.item === null) {
			GetItem(`/experiences/${this.props.match.params.id}`).then(data => {
				this.setState({ item: data.data });
			});
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Copy {this.indefiniteArticle} {this.label}
				</h3>
				{this.state.item ? (
					<ExperienceForm
						cultures={this.props.cultures}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						initialValues={this.state.item}
						buttonLabel={`Create ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	setItem = () => {};

	renderUpdateForm = () => {
		if (this.state.item === null) {
			GetItem(`/experiences/${this.props.match.params.id}`).then(data => {
				this.setState({ item: data.data });
			});
		}
		// const { id } = this.state.item;
		return (
			<div className="ta-center">
				<div className="content-wrap">
					{this.state.item && <ChangeHistory id={this.state.item.id} entity="experiences" />}
					<br />
					<h3 className="page-title">
						Update {this.indefiniteArticle} {this.label}
					</h3>
					{this.state.item ? (
						<ExperienceForm
							cultures={this.props.cultures}
							onSubmit={(values, submitHandler) =>
								this.submitForm(values, submitHandler, this.state.item.id)
							}
							initialValues={this.state.item}
							buttonLabel={`Update ${this.label}`}
							getFormApi={this.props.getFormApi}
							hasFormApi={this.props.hasFormApi}
							id={this.state.item.id}
							actionType="update"
							isUpdateForm
						/>
					) : (
						"Loading..."
					)}
				</div>
			</div>
		);
	};

	render() {
		let content = "Loading";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				break;
		}
		return <Page title="My Experiences">{content}</Page>;
	}
}

ExperienceFormWrapper.propTypes = {
	type: PropTypes.string,
	items: PropTypes.array,
	cultures: PropTypes.array,
	createItem: PropTypes.func,
	copyItem: PropTypes.func,
	updateItem: PropTypes.func,
	match: PropTypes.object,
	getFormApi: PropTypes.func,
	hasFormApi: PropTypes.bool,
};

export default withRouter(ExperienceFormWrapper);
